import {Config} from '../services/config/config.service';
import {inject, Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {HttpClient, HttpParams} from '@angular/common/http';


@Injectable()
export class SportEventsClient {
  private endpoint: string;
  private http = inject(HttpClient);
  private config = inject(Config)

  constructor() {
    this.endpoint = this.config.CONFIG.apiUrl + '/sport_events/pool';
  }

  get(id: number): Observable<any> {
    const params: HttpParams = new HttpParams()
      .set('no_serializer', 'true');

    return this.http.get(this.endpoint + '/' + id, { params })
      .pipe(
        map(data => data),
        catchError(err => throwError(err))
      );
  }
}
